var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td-table',{ref:"historyTable",attrs:{"columns":_vm.columns,"hasPage":true,"hasMutiSelect":false,"dataSource":_vm.tableData,"pageSize":_vm.pageSize,"height":400,"currentPage":_vm.currentPage,"total":_vm.total,"rowKey":_vm.rowKey},on:{"handleSizeChange":_vm.handleSizeChange,"currentChange":_vm.currentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }